<template lang="html">
  <div id="buscar_pedimento_soluciona">
    <div>
      <v-breadcrumbs :items="breadcrumbs">
        <v-icon slot="divider">forward</v-icon>
      </v-breadcrumbs>
      <v-container fluid fill-height>
        <v-row>
          <v-col xs="12">
            <base-material-card color="primary" icon="library_books" title="Buscar Pedimento"
              class="elevation-1 px-5 py-3">
              <v-card-text class="center">
                <v-card-title class="center">
                  <v-spacer />
                  <v-spacer />
                </v-card-title>
                <div class="generador_archivos">
                  <v-form ref="form" lazy-validation class="form_generador">
                    <v-container fluid>
                      <v-row align="center" dense>
                        <v-col sm="10">
                          <v-text-field v-model="no_pedimento" label="No. Pedimento" :rules="[rules.required]" />
                        </v-col>
                        <v-col sm="2" style="text-align:center;">
                          <v-btn color="success" small @click="buscar">
                            Buscar
                          </v-btn>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12">
                          <v-card-title>
                            <v-spacer />


                          </v-card-title>
                        </v-col>
                      </v-row>
                      <br>
                      <div v-if="existe">
                        <v-row>
                          <v-col sm="12" md="5" class="form_generador">
                            <center><strong>Resultado de la Busqueda en DS/WS</strong></center>
                            <div class="resultado_busqueda">
                              <span>No. Pedimento:<span>{{ item.no_pedimento }}</span></span>
                              <span>Clave de Documento:<span>{{ item.clave_documento }}</span></span>
                              <span>Tipo de Operación:<span>{{ item.tipo_operacion }}</span></span>
                              <span>Fecha de Pago:<span>{{ item.fecha_pago }}</span></span>
                              <span>Rectificación:<span>{{ item.rectificacion != false ? item.rectificacion : 'Sin Rectificación'}}</span></span>
                            </div>
                          </v-col>
                          <v-spacer />
                          <v-col sm="12" md="5" class="form_generador">
                            <center><strong>Resultado de la Busqueda en SA31</strong></center>
                            <center v-if="item.eliminado != false"><span class="red--text">** El Pedimento fue eliminado
                                de SolucionA31 **</span></center>
                            <center v-if="item.soluciona == false && item.eliminado == false"><span class="blue--text">**
                                El Pedimento no aplica para SolucionA31 **</span></center>
                            <div v-if="item.soluciona || item.eliminado != false" class="resultado_busqueda">
                              <span>No. Pedimento:<span>{{ item.no_pedimento }}</span></span>
                              <span>Clave de Documento:<span>{{ item.clave_documento }}</span></span>
                              <span>Tipo de Operación:<span>{{ item.tipo_operacion }}</span></span>
                              <span>Fecha de Pago:<span>{{ item.fecha_pago }}</span></span>
                              <span>Origen:<span>{{ item.origen }}</span></span>
                              <span v-if="item.eliminado != false">Anotación:<span>{{ item.eliminado }}</span></span>
                              <center v-if="item.soluciona">
                                <v-btn color="red" small @click="dialog1 = true;">
                                  Eliminar
                                </v-btn>
                              </center>
                            </div>
                          </v-col>
                        </v-row>
                        <br>
                      </div>

                    </v-container>
                  </v-form>
                </div>
              </v-card-text>
            </base-material-card>
          </v-col>
        </v-row>
      </v-container>
    </div>

    <v-dialog v-model="dialog1" max-width="500px">
      <v-card>
        <v-card-text>
          <h5>¿Está seguro de eliminar el pedimento de SolucionA31?</h5>
          <br>
          <v-form ref="form_eliminar" lazy-validation="">
            <v-textarea outlined rows="5" v-model="motivo" :rules="[rules.required]" label="Motivo"></v-textarea>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn small color="blue" @click="dialog1 = false">Cancelar</v-btn>
          <v-spacer></v-spacer>
          <v-btn small color="red" @click="eliminar_pedimento">Eliminar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";

export default {
  created: function () {
  },
  computed: {
  },
  data: () => ({
    item: {},
    no_pedimento: '',
    dialog1: false,
    existe: false,
    folio_nuevo: '',
    breadcrumbs: [{
      text: "Inicio",
      disabled: false,
      to: "/home"
    },
    {
      text: "Buscar Pedimento",
      disabled: true,
      to: ""
    }
    ],
    motivo: "",
    rules: {
      required: v => !!v || "Este campo es requerido",
    },

  }),
  methods: {
    buscar: function () {
      this.existe = false;

      if (!this.$refs.form.validate()) {
        return
      }

      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');

      let data = {
        rfc: this.$local_storage.get("rfc"),
        no_pedimento: this.no_pedimento
      };
      axios.post(this.$apiSA31 + "soluciona31/buscar_pedimento/", data).then(res => {
        if (typeof res.data !== "undefined") {
          if (!res.data.encontrado) {
            this.$root.$dialogLoader.hide();
            this.$swal({
              type: "error",
              title: "¡Operación no Permitida!",
              text: "No existe el pedimento",
              footer: ""
            });
          } else {
            this.item = res.data;
            this.existe = true;
            this.$root.$dialogLoader.hide();
          }
        }
      }).catch(err => {
        console.log(err);
        this.$root.$dialogLoader.hide();
        this.$swal({
          type: "error",
          title: "¡Operación no Permitida!",
          text: "Ocurrió un error al hacer la busqueda",
          footer: ""
        });
      });
    },
    eliminar_pedimento: function () {
      if (!this.$refs.form_eliminar.validate()) {
        return
      }

      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');

      let data = {
        id_pedimento: this.item.id,
        motivo: this.motivo
      };

      axios.post(this.$apiSA31 + "soluciona31/eliminar_pedimento/", data).then(res => {
        if (typeof res.data !== "undefined") {
          this.$swal({
            type: "success",
            title: "¡Operación Exitosa!",
            text: "El Pedimento fue eliminado correctamente de SolucionA31",
            footer: ""
          });
        }
      }).catch(err => {
        console.log(err);
        this.$swal({
          type: "error",
          title: "¡Operación no Permitida!",
          text: "Ocurrió un error al hacer la busqueda",
          footer: ""
        });
      }).then(() => {
        this.dialog1 = false;
        this.$root.$dialogLoader.hide();
        this.buscar();
      });

    }
  },
}
</script>

<style lang="css" scoped>
.generador_archivos {
  display: flex;
  align-items: center;
  justify-content: center;
}

.form_generador {
  width: 70%;
  border-radius: 15px;
  border: 1px solid lightgray;
}

.resultado_busqueda {
  display: flex;
  flex-direction: column;
  gap: 2px;
  margin-top: 15px;
}

.resultado_busqueda>span {
  display: flex;
  justify-content: space-between;
}</style>
